export const isDarkKey = Symbol();
